// Ordena la lista de "Mis Pedidos" de más reciente a más antiguo en el frontend,
// como defensa en profundidad ante que el backend no aplique de forma confiable
// su propio parámetro `orden=desc` (ver getOrdersByUser en src/api/index.js).
//
// Se usa `pedido_id` (numérico, autoincremental) como criterio de orden en vez de
// `pedido_fecha`, porque el formato de esta última no está confirmado de forma
// unívoca entre endpoints (DD-MM-YYYY en la captura real de QA vs. ISO en algunos
// mocks de test) y parsear un formato ambiguo es más fragil que confiar en el id.
//
// Nunca lanza: una respuesta que no sea un array se trata como lista vacía, y
// pedidos con `pedido_id` no numérico se colocan al final sin romper el resto.
export const sortOrdersByRecency = (orders) => {
  if (!Array.isArray(orders)) return [];

  return [...orders].sort((a, b) => {
    const idA = Number(a?.pedido_id);
    const idB = Number(b?.pedido_id);
    const validA = Number.isFinite(idA);
    const validB = Number.isFinite(idB);

    if (validA && validB) return idB - idA;
    if (validA) return -1;
    if (validB) return 1;
    return 0;
  });
};
